export interface PageParts {
  readonly couponImageUrl: string,
  readonly freeContentHtml: string,
  readonly freeContentScript: string,
  readonly freeContentStyle: string,
}

interface GameResultResponse {
  redirect_url?: string,
  page_parts?: {
    coupon_image_url: string,
    free_content_html: string,
    free_content_script: string,
    free_content_style: string,
  },
}

export class GameResult {

  constructor(
    private readonly _data: GameResultResponse
  ) {}

  get redirectUrl(): string | undefined {
    return this._data.redirect_url
  }

  get pageParts(): PageParts | undefined {
    if (!this._data.page_parts) {
      return undefined
    }

    return {
      couponImageUrl: this._data.page_parts.coupon_image_url,
      freeContentHtml: this._data.page_parts.free_content_html,
      freeContentScript: this._data.page_parts.free_content_script,
      freeContentStyle: this._data.page_parts.free_content_style,
    }
  }
}
